// extracted by mini-css-extract-plugin
var _1 = "SortPopover_informative__4ce71";
var _2 = "SortPopover_root__abb3b";
export { _1 as "informative", _2 as "root" }
